import axiosBase, { AxiosError } from 'axios';
import { User } from '../contexts/UserContext';
import {
  getUser,
  updateUser,
  setLastRequestId,
  setLastFailedRequestId,
} from './storage';

export const isCancel = axiosBase.isCancel;
export const CancelToken = axiosBase.CancelToken;
export const loginPath = '/login';
export const axiosKK = axiosBase.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

function setToken() {
  const userObject = getUser();
  if (userObject) {
    axiosKK.defaults.headers.common['Authorization'] =
      'bearer ' + userObject.token;
  }
}
setToken();

function updateStoredUser(newState: (user: User) => User) {
  updateUser(newState);
}

// Module-level guard so concurrent 401s don't fire multiple
// `window.location.assign` calls (admin pages issue many parallel requests).
let isRedirectingToLogin = false;

axiosKK.interceptors.response.use(
  (response) => {
    const updatedToken = response.data.jwt;
    if (updatedToken) {
      axiosKK.defaults.headers.common['Authorization'] =
        'bearer ' + updatedToken;

      updateStoredUser((user) => {
        user.token = updatedToken;

        return user;
      });

      // delete response.data.jwt;
    }

    const requestId = response.headers['x-request-id'];
    if (requestId) {
      setLastRequestId(requestId);
    }

    return response;
  },
  function (error: AxiosError) {
    const status = error.response?.status;

    const requestId = error.response?.headers?.['x-request-id'];
    if (requestId) {
      setLastFailedRequestId(requestId as string);
    }

    if (status === 401) {
      updateStoredUser((user) => {
        delete user.token;

        return user;
      });
      if (window.location.pathname !== loginPath && !isRedirectingToLogin) {
        isRedirectingToLogin = true;
        window.location.assign(loginPath);
      }
    }

    return Promise.reject(error);
  },
);
